import script from "./daily-tasks.vue?vue&type=script&setup=true&lang=js"
export * from "./daily-tasks.vue?vue&type=script&setup=true&lang=js"

import "./daily-tasks.vue?vue&type=style&index=0&id=71cebe7b&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.21_vue@3.5.21_webpack@5.106.1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-71cebe7b"]])

export default __exports__